angular.module('autoremind.reports.todo', [])
    .directive('reportsTodo', ['$rootScope', 'todoService', 'dialogs', '$uibModal', '$filter', '$location', 'eventSharingService',
    function ($rootScope, todoService, dialogs, $uibModal, $filter, $location, eventSharingService) {
        console.log('reportsTodo');
        return {
            restrict: 'EA',
            templateUrl: 'app/reports/todo/todo.html',
            scope: false,
            link: function (scope, elem, attr) {
                var routeListener;
                routeListener = $rootScope.$on("$routeChangeStart", function (event, next, current) {
                    todoService.destroy();
                });
                scope.todoService = todoService;
                scope.$on('$destroy', routeListener);
                todoService.loadOptions()
                    .then(function (response) {
                    if (scope.todoService.optionsNew) {
                        scope.openSettingsDialog();
                    }
                    todoService.loadTasksByDay(todoService.chosenDateShort);
                });
                scope.oneTaskStateIsChanged = function (task, keyOnTasksObject, indexOnTemplate) {
                    scope.showSpinner(keyOnTasksObject, indexOnTemplate);
                    var responseFromSaveTask = function () {
                        scope.hideSpinner(keyOnTasksObject, indexOnTemplate);
                        todoService.markSubGroup(keyOnTasksObject);
                        todoService.calculateTasksNotDone(todoService.chosenDateShort);
                    };
                    todoService.saveTasksChanges([{ taskId: task.id, taskState: task.isDone }])
                        .then(responseFromSaveTask, responseFromSaveTask);
                };
                scope.groupTasksStateIsChanged = function (groupId, value) {
                    //value(true or false)
                    scope.showSpinner(groupId, groupId);
                    scope.makeChildrenDiasabled(groupId);
                    var responseFromSaveTasks = function () {
                        scope.hideSpinner(groupId, groupId);
                        scope.makeChildrenEnabled(groupId);
                        // JACOB: why enable children on error from saving? or just bad name?
                        todoService.calculateTasksNotDone();
                    };
                    todoService.markAllTasksBySubgroupAndSave(groupId, value)
                        .then(responseFromSaveTasks, responseFromSaveTasks);
                };
                scope.showSpinner = function (groupId, index) {
                    angular.element('.loader-' + groupId + '-' + index).css("display", "block");
                    angular.element('#checkbox-' + groupId + '-' + index).css("display", "none");
                    angular.element('#checkbox-' + groupId + '-' + index).attr("disabled", true);
                };
                scope.hideSpinner = function (groupId, taskId) {
                    angular.element('.loader-' + groupId + '-' + taskId).css("display", "none");
                    angular.element('#checkbox-' + groupId + '-' + taskId).css("display", "");
                    angular.element('#checkbox-' + groupId + '-' + taskId).removeAttr('disabled');
                };
                scope.makeChildrenDiasabled = function (groupId) {
                    angular.element('.patients-' + groupId + '-input').attr("disabled", true);
                };
                scope.makeChildrenEnabled = function (groupId) {
                    angular.element('.patients-' + groupId + '-input').removeAttr('disabled');
                };
                scope.todoReportData = {};
                scope.todoReportData.haveChanges = false;
                scope.todoReportData.todoTasks = todoService.tasks;
                scope.openSettingsDialog = function (size) {
                    var modalInstance;
                    var modalScope = scope.$new();
                    modalScope.success = function () {
                        modalInstance.close(modalScope.selected);
                    };
                    modalScope.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                    modalInstance = $uibModal.open({
                        template: '<modal-config-dialog></modal-config-dialog>',
                        size: 'lg',
                        scope: modalScope,
                        backdrop: 'static'
                    });
                    modalInstance.result.then(function (selectedItem) {
                        todoService.tmpOptions = [];
                    }, function () {
                        todoService.tmpOptions = [];
                    });
                };
                scope.datepickers = [{ open: false }, { open: false }];
                scope.toggleDatepicker = function ($event, index) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.datepickers[index].open = !scope.datepickers[index].open;
                };
                scope.dateWasChanged = function (date) {
                    todoService.chosenDateShort = $filter('date')(date, 'yyyy-MM-dd');
                    todoService.loadTasksByDay(todoService.chosenDateShort);
                };
                scope.printPage = function () {
                    var innerContents = angular.element(document.getElementById('forPrintReport')).clone();
                    // var content = document.getElementById('forPrintReport').innerHTML;
                    innerContents.find('.removeForPrint').remove();
                    var template = '<style>@page{size:landscape;}</style><html><head><link rel="stylesheet" type="text/css" href="css/app.css" />' +
                        '<link rel="stylesheet" type="text/css" href="lib/bootstrap-3.3.4/bootstrap.min.css" /></head>' +
                        '<body class="printDialog" onload="window.print();">' +
                        '' + innerContents.html() + '' +
                        '</body>' +
                        '</html>';
                    var popupWindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                    popupWindow.document.open();
                    popupWindow.document.write(template);
                    popupWindow.document.close();
                };
                scope.setRouteNg2 = function (url, personid) {
                    // Changing URL as its displaying encoded url in browser
                    $location.url('/patients?patientid=' + personid);
                    var params = {};
                    params['patientid'] = personid;
                    eventSharingService.setRoute(url, params);
                };
            }
        };
    }])
    .directive('todoSaveChangesLoader', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'EA',
            scope: false,
            template: function () {
                return "<div class='sk-fading-circle'>" +
                    "<div class='sk-circle1 sk-circle'></div>" +
                    "<div class='sk-circle2 sk-circle'></div>" +
                    "<div class='sk-circle3 sk-circle'></div>" +
                    "<div class='sk-circle4 sk-circle'></div>" +
                    "<div class='sk-circle5 sk-circle'></div>" +
                    "<div class='sk-circle6 sk-circle'></div>" +
                    "<div class='sk-circle7 sk-circle'></div>" +
                    "<div class='sk-circle8 sk-circle'></div>" +
                    "<div class='sk-circle9 sk-circle'></div>" +
                    "<div class='sk-circle10 sk-circle'></div>" +
                    "<div class='sk-circle11 sk-circle'></div>" +
                    "<div class='sk-circle12 sk-circle'></div>" +
                    "</div>";
            },
            link: function (scope, element, attrs, controller) {
            }
        };
    }]);
//# sourceMappingURL=todo.directive.js.map